module.exports = __webpack_public_path__ + "static/3-min-a37f12da69f590bb5a9f00aa0128873a.jpg";